import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderGridContainerComponent } from './grid-container.component';


@NgModule({
  declarations: [
    RappiderGridContainerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RappiderGridContainerComponent
  ]
})
export class RappiderGridContainerModule { }
